// This file is generated by php artisan donation-currencies:generate-js.
// Do not edit it directly. Update App\Constants\Donations\DonationCurrency instead.

export const DONATION_CURRENCIES = [
  {
    "id": "USD",
    "name": "USD - US Dollar",
    "symbol": "$",
    "locale": "en-US",
    "stripeFixedFee": 0.3
  },
  {
    "id": "CAD",
    "name": "CAD - Canadian Dollar",
    "symbol": "$",
    "locale": "en-CA",
    "stripeFixedFee": 0.3
  },
  {
    "id": "GBP",
    "name": "GBP - British Pound",
    "symbol": "£",
    "locale": "en-GB",
    "stripeFixedFee": 0.2
  }
]

export const DEFAULT_DONATION_CURRENCY_CODE = "USD"

export const DONATION_CURRENCY_BY_COUNTRY_CODE = {
  "US": "USD",
  "CA": "CAD",
  "GB": "GBP"
}
